import { defineStore } from 'pinia';
import { computed, ref } from 'vue';

import type { User } from '@/shared/api';

import { useUserGetMe } from '../../api';

const initStore = () => {
  const { userGetMe } = useUserGetMe();

  const user = ref<User | null>(null);
  const isFetched = ref<boolean>(false);

  const isAuth = computed<boolean>(() => isFetched.value && !!user.value?.id);

  const fetchUser = async (): Promise<void> => {
    const { data } = await userGetMe();

    user.value = data ?? null;
    isFetched.value = true;
  };

  return { user, isFetched, isAuth, fetchUser };
};

const useUserStore = defineStore('user', initStore);

export { useUserStore };
